import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { LocaService } from '../../../service/loca/loca.service';
import { AbcService } from '../../../service/abc/abc.service';
import { LocaBlockService } from '../../../service/loca-block/loca-block.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { TypeItemService } from 'app/service/type-item/type-item.service';

@Component({
  selector: 'wa9121',
  templateUrl: 'wa9121.component.html',
  styleUrls: ['wa9121.component.scss']
})
export class Wa9121Component implements OnInit, OnChanges {
  public componentTitle = 'WA9121:ロケマスタ登録';

  public abcs: any;
  public locablocks: any;
  public typecolds: any;
  public typestocks: any;
  public typeitems: any;

  public locaCd: FormControl;
  public locaTx: FormControl;
  public locabarcodeTx: FormControl;
  public srclocaCd: FormControl;
  public typecoldCd: FormControl;
  public typeitemCd: FormControl;
  public typestockCd: FormControl;
  public locablockCd: FormControl;
  public locaabcId: FormControl;
  public arrivepriorityNr: FormControl;
  public shippriorityNr: FormControl;
  public notarriveFl = 0;
  public notshipFl = 0;
  public mixitemFl = 1;
  public mixlotFl = 1;
  public mixuselimitFl = 1;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isLoginButtonEnabled = false;
  private isLocaCdClassActive = false;
  private isLocaCdClassError = false;
  private isLocaTxClassActive = false;
  private isLocaTxClassError = false;
  private isLocaBarCodeTxClassActive = false;
  private isLocaBarCodeTxClassError = false;
  private isTypestockCdClassActive = false;
  private isTypeCodeCdClassActive = false;
  private isTypeItemCdClassActive = false;
  private isLocaBlockCdClassActive = false;
  private isLocaAbcIdClassActive = false;
  private isArrivePriorityNrClassActive = false;
  private isArrivePriorityNrClassError = false;
  private isShippriorityNrClassActive = false;
  private isShippriorityNrClassError = false;
  private isSrclocaCdClassActive = false;
  private isSrclocaCdClassError = false;

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  constructor(
    private router: Router,
    private locaService: LocaService,
    private abcService: AbcService,
    private locaBlockService: LocaBlockService,
    private typeColdService: TypeColdService,
    private typeItemService: TypeItemService,
    private typeStockService: TypeStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    (this.locaCd = new FormControl('', [Validators.pattern(validation.halfBlankOnly), Validators.pattern(validation.code39), Validators.maxLength(validation.locaCd.maxLength)])),
      (this.locaTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.locaTx.maxLength)
      ])),
      (this.locabarcodeTx = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.locabarcodeTx.maxLength)
      ])),
      (this.srclocaCd = new FormControl('', [
        Validators.maxLength(validation.srclocaCd.maxLength)
      ])),
      (this.arrivepriorityNr = new FormControl(999999, [
        Validators.pattern(validation.integer),
        Validators.max(validation.arrivepriorityNr.maxNr),
        Validators.min(validation.arrivepriorityNr.minNr)
      ])),
      (this.shippriorityNr = new FormControl(999999, [
        Validators.pattern(validation.integer),
        Validators.max(validation.shippriorityNr.maxNr),
        Validators.min(validation.shippriorityNr.minNr)
      ])),
      (this.typestockCd = new FormControl('', [Validators.required])),
      (this.typecoldCd = new FormControl('', [Validators.required])),
      (this.locablockCd = new FormControl('', [Validators.required])),
      (this.typeitemCd = new FormControl('', [Validators.required])),
      (this.locaabcId = new FormControl('', [Validators.required])),
      (this.containerHeight = window.innerHeight - config.containerheaderMargin);
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    // TODO should be execute parallel, but API server don't work properly
    this.typeStockService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.typestocks = outputJson.typestocks;
        this.typeColdService
          .get()
          .then(_outputJson => {
            console.log(JSON.stringify(_outputJson));
            this.typecolds = _outputJson.typecolds;
            this.locaBlockService
              .get()
              .then(__outputJson => {
                console.log(JSON.stringify(__outputJson));
                this.locablocks = __outputJson.locablocks;
                this.abcService
                  .get()
                  .then(___outputJson => {
                    this.working = false;
                    console.log(JSON.stringify(___outputJson));
                    this.abcs = ___outputJson.abcs;
                  })
                  .catch(error => {
                    this.working = false;
                    this.errorInfo = this.commonService.getErrorMessage(error);
                  });
              })
              .catch(error => {
                this.working = false;
                this.errorInfo = this.commonService.getErrorMessage(error);
              });
          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
      this.typeItemService
        .get()
        .then(____outputJson => {
          this.typeitems = ____outputJson.itemcategories;
        })
        .catch(error => {
          this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isLoginButtonEnabled)
      return;
    var locaCd = this.locaCd.value.trim();
    var locaTx = this.locaTx.value.trim();
    var locabarcodeTx = this.locabarcodeTx.value.trim();
    var srclocaCd = this.srclocaCd.value.trim();
    let errors = false;
    if (this.locaCd.errors !== null) {
      this.locaCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locaTx.errors !== null) {
      this.locaTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locabarcodeTx.errors !== null) {
      this.locabarcodeTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.srclocaCd.errors !== null) {
      this.srclocaCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.arrivepriorityNr.errors !== null) {
      this.arrivepriorityNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shippriorityNr.errors !== null) {
      this.shippriorityNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    /*
    if (this.typestockCd.errors !== null) {
      console.log('------- submit2-7');
      this.typestockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typecoldCd.errors !== null) {
      console.log('------- submit2-8');
      this.typecoldCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    */
    if (this.locablockCd.errors !== null) {
      this.locablockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    /*
    if (this.locaabcId.errors !== null) {
      console.log('------- submit2-30');
      this.locaabcId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    */
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    const upduserId: number = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.locaService
      .post(
        locaCd,
        locaTx,
        locabarcodeTx,
        '',
        this.typestockCd.value,
        this.typecoldCd.value,
        this.typeitemCd.value,
        this.locablockCd.value,
        this.locaabcId.value,
        this.arrivepriorityNr.value,
        this.shippriorityNr.value,
        this.notarriveFl,
        this.notshipFl,
        this.mixitemFl,
        this.mixlotFl,
        this.mixuselimitFl,
        srclocaCd,
        upduserId,
        'wa9121'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();

      setTimeout(() => {
        this.scrollContent.nativeElement.scrollTop = 0;
      }, 200);
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.errorInfo = '';
    this.locaCd.setValue('');
    this.locaTx.setValue('');
    this.locabarcodeTx.setValue('');
    this.srclocaCd.setValue('');
    this.typecoldCd.setValue('10');
    this.typestockCd.setValue('10');
    this.typeitemCd.setValue('');
    this.locablockCd.setValue('');
    this.locaabcId.setValue('0');
    this.arrivepriorityNr.setValue(999999);
    this.shippriorityNr.setValue(999999);
    this.notarriveFl = 0;
    this.notshipFl = 0;
    this.mixitemFl = 1;
    this.mixlotFl = 1;
    this.mixuselimitFl = 1;

    this.isLoginButtonEnabled = false;
    this.isLocaCdClassActive = false;
    this.isLocaCdClassError = false;
    this.isLocaTxClassActive = false;
    this.isLocaTxClassError = false;
    this.isLocaBarCodeTxClassActive = false;
    this.isLocaBarCodeTxClassError = false;
    this.isTypestockCdClassActive = false;
    this.isTypeCodeCdClassActive = false;
    this.isTypeItemCdClassActive = false;
    this.isLocaBlockCdClassActive = false;
    this.isLocaAbcIdClassActive = false;
    this.isArrivePriorityNrClassActive = false;
    this.isArrivePriorityNrClassError = false;
    this.isShippriorityNrClassActive = false;
    this.isShippriorityNrClassError = false;
    this.isSrclocaCdClassActive = false;
    this.isSrclocaCdClassError = false;
  }

  locaCdClass() {
    return {
      active: this.isLocaCdClassActive,
      error: this.isLocaCdClassError
    }
  }
  onLocaCdInput(event) {
    this.errorInfo = '';

    this.isLocaCdClassActive = event.target.value !== '';
    this.locaCd.setValue(event.target.value);
    this.isLocaCdClassError = this.locaCd.invalid;
    this.checkLoginButtonState();
  }

  locaTxClass() {
    return {
      active: this.isLocaTxClassActive,
      error: this.isLocaTxClassError
    }
  }
  onLocaTxInput(event) {
    this.errorInfo = '';

    this.isLocaTxClassActive = event.target.value !== '';
    this.locaTx.setValue(event.target.value);
    this.isLocaTxClassError = this.locaTx.invalid;
    this.checkLoginButtonState();
  }

  locabarCodeTxClass() {
    return {
      active: this.isLocaBarCodeTxClassActive,
      error: this.isLocaBarCodeTxClassError
    }
  }
  onLocaBarCodeTxInput(event) {
    this.errorInfo = '';

    this.isLocaBarCodeTxClassActive = event.target.value !== '';
    this.locabarcodeTx.setValue(event.target.value);
    this.isLocaBarCodeTxClassError = this.locabarcodeTx.invalid;
    this.checkLoginButtonState();
  }

  onTypestockCdChanged() {
    this.errorInfo = '';

    this.isTypestockCdClassActive = this.typestockCd.value !== '10';
    this.checkLoginButtonState();
  }

  onTypeCodeCdChanged() {
    this.errorInfo = '';

    this.isTypeCodeCdClassActive = this.typecoldCd.value !== '10';
    this.checkLoginButtonState();
  }

  onTypeItemCdChanged() {
    this.errorInfo = '';

    this.isTypeItemCdClassActive = this.typeitemCd.value !== '';
    this.checkLoginButtonState();
  }

  onLocaBlockCdChanged() {
    this.errorInfo = '';

    this.isLocaBlockCdClassActive = this.locablockCd.value !== '';
    this.checkLoginButtonState();
  }

  onLocaAbcIdChanged() {
    this.errorInfo = '';

    this.isLocaAbcIdClassActive = this.locaabcId.value !== '0';
    this.checkLoginButtonState();
  }

  arrivePriorityNrClass() {
    return {
      active: this.isArrivePriorityNrClassActive,
      error: this.isArrivePriorityNrClassError
    }
  }

  onArrivePriorityNrInput(event) {
    this.errorInfo = '';

    this.isArrivePriorityNrClassActive = event.target.value !== '';
    this.arrivepriorityNr.setValue(event.target.value);
    this.isArrivePriorityNrClassError = this.arrivepriorityNr.invalid;
    this.checkLoginButtonState();
  }

  shippriorityNrClass() {
    return {
      active: this.isShippriorityNrClassActive,
      error: this.isShippriorityNrClassError
    }
  }

  onShippriorityNrInput(event) {
    this.errorInfo = '';

    this.isShippriorityNrClassActive = event.target.value !== '';
    this.shippriorityNr.setValue(event.target.value);
    this.isShippriorityNrClassError = this.shippriorityNr.invalid;
    this.checkLoginButtonState();
  }

  srclocaCdClass() {
    return {
      active: this.isSrclocaCdClassActive,
      error: this.isSrclocaCdClassError
    }
  }
  onSrclocaCdInput(event) {
    this.errorInfo = '';

    this.isSrclocaCdClassActive = event.target.value !== '';
    this.srclocaCd.setValue(event.target.value);
    this.isSrclocaCdClassError = this.srclocaCd.invalid;
    this.checkLoginButtonState();
  }

  checkLoginButtonState() {
    this.isLoginButtonEnabled =
      this.isLocaCdClassActive && this.locaCd.errors == null &&
      this.isLocaTxClassActive && this.locaTx.errors == null &&
      this.isLocaBarCodeTxClassActive && this.locabarcodeTx.errors == null &&
      this.isLocaBlockCdClassActive && this.locablockCd.errors == null &&
      this.srclocaCd.errors == null &&
      (this.arrivepriorityNr.value + '').length > 0 && this.arrivepriorityNr.errors == null &&
      (this.shippriorityNr.value + '').length > 0 && this.shippriorityNr.errors == null;
  }
  ngDocheck() {
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9121/wa9121.component.ts